import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { ROUTES } from '../../constants/routes';
import { localStorageService } from '../../services/localStorageService/localStorageService';

/** Drops the stored session and returns to the organisation login. */
export const useDashboardLogout = () => {
  const navigate = useNavigate();

  return useCallback(() => {
    const storage = localStorageService();
    storage.removeAccessToken();
    storage.removeRefreshToken();
    storage.removeUserId();
    navigate(`/${ROUTES.ORGANISATION_LOGIN}`);
  }, [navigate]);
};
